import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "sps-workflow, sps-wf",
    templateUrl: "./sps-workflow.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsWorkflowComponent {
    static readonly displayName = "sps-workflow, sps-wf";
    static readonly props = {
        title: "string",
        icon: "string",
    };

    @HostBinding("class.sps-workflow") readonly _spsWorkflowClass = true;

    @Input() title: string;
    @Input() icon: string;
}
